export default __webpack_public_path__ + "static/media/mhpss.75e98f36.png";